module.exports = __webpack_public_path__ + "img/trinity-read-pdfs.3e6f73b9.png";